import { Navigate, Outlet } from 'react-router-dom';
import { useSelector} from 'react-redux';


const RolePermissionRoute = ({ roles, redirectPath = '/index', children }) => {
    const {userLogged} = useSelector( state => state.userLogged);

    for (const role of roles) {
        if (role === userLogged.role) {
            return children ? children : <Outlet />;
        }
    }

    return <Navigate to={redirectPath} replace />;
};

export default RolePermissionRoute;